export const streamFieldKey = (streamID) => `stream-${streamID}`;

export function getHeatmapClassesInResponseOrder(heatmap) {
  const classes = new Map();

  (Array.isArray(heatmap) ? heatmap : []).forEach((snapshot) => {
    if (snapshot?.classID == null || classes.has(snapshot.classID)) return;
    classes.set(snapshot.classID, {
      id: snapshot.classID,
      name: snapshot.className,
    });
  });

  return [...classes.values()];
}

export function buildStreamComparisonMatrix(response) {
  const streams = new Map();
  const subjects = Array.isArray(response?.subjects) ? response.subjects : [];

  const rows = subjects.map((subject) => {
    const row = {
      subjectID: subject?.subjectID,
      subjectName: subject?.subjectName,
      subjectCategory: subject?.subjectCategory,
    };

    (Array.isArray(subject?.streams) ? subject.streams : []).forEach((stream) => {
      if (stream?.streamID == null) return;
      if (!streams.has(stream.streamID)) {
        streams.set(stream.streamID, {
          streamID: stream.streamID,
          streamName: stream.streamName,
        });
      }
      row[streamFieldKey(stream.streamID)] = stream;
    });

    return row;
  });

  return { streams: [...streams.values()], rows };
}
